module.exports = __webpack_public_path__ + "img/img-3.38d60099.png";